<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
      <v-data-table
              no-data-text="Нет новостей"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="jobRequests"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :search="search"
              :options.sync="options"
              :footer-props="footerProps"
              :loading="loading"
              :items-per-page="-1"
              loading-text="Загрузка новостей... Подождите пожалуйста"
      >
        <template v-slot:item.cv="{ item }">
          <a :href="item.cv_url">Скачать</a>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="$router.push({ name: 'job-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
</template>

<script>
  // @ is an alias to /src

  import JobService from './../../../api/JobService'
  export default {
    name: 'JobRequest',
    components: {},
    data: () => ({
      submitDialog: false,
      submitItem: null,
      selected: [],
      filters: {
      },
      overlay: false,
      search: '',
      loading: true,
      categories: [],
      options: {},
      footerProps: {
        itemsPerPageText: 'Резюме на страницу',
        pageText: '{0}-{1} из {2}',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [-1]
      },
      total: 0,
      headers: [
        {
          text: 'Вакансия',
          value: 'job.name',
          sortable: false,
        },
        {
          text: 'Имя',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Телефон',
          value: 'phone',
          sortable: false,
        },
        {
          text: 'Почта',
          value: 'email',
          sortable: false,
        },
        {
          text: 'Резюме',
          value: 'cv',
          sortable: false,
        },
        {
          text: 'Комментарий',
          value: 'comment',
          sortable: false,
        },
      ],
      jobRequests: [],
    }),
    mounted() {
    },
    watch: {
      options: {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      search() {
        this.getDataFromApi()
      }
    },
    methods: {
      submitDelete(item = null){
        if(item){
          this.removeJob(item)
        } else {
          this.massDelete()
        }
      },
      collectSelectedId(){
        let ids = [];
        this.selected.forEach(function (item) {
          ids.push(item.id)
        })

        return ids;
      },
      massDelete(){
        let params = {
          ids: this.collectSelectedId()
        };

        JobService.massEdit('delete', params).then(response => {
          this.getDataFromApi()
        })
      },
      removeJob(item){
        JobService.remove(item.id).then(response => {
          this.loading = true
          this.getDataFromApi()
        })
      },
      getDataFromApi() {
        this.loading = true

        let params = {
          search: this.search,
        }
        JobService.listRequests(params)
          .then(response => {
            this.jobRequests = response.data
            this.loading = false
          })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }

    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
